import React, { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import data from '../../config/objects.json'
import useStore from '../../store'
import './Artists.css'

const createGlow = (glowColor) => ({
  WebkitFilter: `drop-shadow(0 0 15px ${glowColor})`,
  filter: `drop-shadow(0 0 15px ${glowColor})`,
})

const ImageLink = ({
  src,
  name,
  to,
  height,
  translateY,
  glowColor,
  hoverImg,
  className,
}) => {
  const playByName = useStore((state) => state.playByName)
  const [hovered, setHovered] = useState(false)

  const linkStyle = translateY && {
    transform: `translateY(${translateY})`,
    zIndex: 999,
  }

  const imgStyle = {
    height,
    ...hovered && createGlow(glowColor),
  }

  const onMouseEnter = useCallback(() => {
    setHovered(true)
    playByName(name, 'hover')
  }, [name, playByName])

  const onClick = useCallback(() => {
    playByName(name, 'click')
    setHovered(false)
  }, [playByName, name])

  return (
    <>
      <Link
        to={to}
        style={linkStyle}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setHovered(false)}
        onClick={onClick}
        className={className}
      >
        <img src={src} alt={name} style={imgStyle} />
      </Link>

      {hoverImg && (
        <img
          src={hoverImg}
          alt={name}
          className={classNames('g-artists-face', {
            'g-artists-face-show': hovered,
          })}
          style={createGlow(glowColor)}
        />
      )}
    </>
  )
}

const Artists = () => {
  return (
    <div className="g-artists">
      <div className="g-artists-link">
        <ImageLink
          name="Diaz"
          src="/assets/images/menu/DIAZ_MenuIcon.png"
          hoverImg="/assets/images/hover/DIAZ Face icon.png"
          to="/laura-diaz"
          height="11vh"
          glowColor={data.Cone.glowColor}
        />
        <ImageLink
          name="Mexa"
          src="/assets/images/menu/MEXA_MenuIcon.png"
          hoverImg="/assets/images/hover/MEXA Face icon.png"
          to="/mexa"
          height="11vh"
          translateY="2.3vh"
          glowColor={data.TorusKnot.glowColor}
        />
        <ImageLink
          name="Miss Tacacá"
          src="/assets/images/menu/MT_MenuIcon.png"
          hoverImg="/assets/images/hover/MT Face icon.png"
          to="/miss-tacaca"
          height="16vh"
          glowColor={data.Torus.glowColor}
        />
        <ImageLink
          name="ótimoKaráter"
          src="/assets/images/menu/OK_MenuIcon.png"
          hoverImg="/assets/images/hover/oK Face icon.png"
          to="/otimokarater"
          height="14vh"
          translateY="1vh"
          glowColor={data.Dodecahedron.glowColor}
        />
        <ImageLink
          name="Podeserdesligado"
          src="/assets/images/menu/PSD_MenuIcon.png"
          hoverImg="/assets/images/hover/PSD Face icon.png"
          to="/podeserdesligado"
          height="15vh"
          glowColor={data.Sphere.glowColor}
        />
        <ImageLink
          name="XIAO QUAN"
          src="/assets/images/menu/XQ_MenuIcon.png"
          hoverImg="/assets/images/hover/XQ Face icon.png"
          to="/xiao-quan"
          height="12vh"
          translateY="1.5vh"
          glowColor={data.Box.glowColor}
        />
        <ImageLink
          className="g-artists-info"
          name="Info"
          src="/assets/images/menu/INFO_MenuIcon.png"
          glowColor="#fff"
          to="/info"
          height="10vh"
        />
      </div>

      <ImageLink
        className="g-artists-mobile"
        name="Info"
        src="/assets/images/menu/INFO_MenuIcon.png"
        glowColor="#fff"
        to="/info"
        height="10vh"
      />
    </div>
  )
}

export default Artists
